function hideProductModal() {
  const productModal = document.querySelectorAll("product-modal[open]");
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener("shopify:block:select", function (event) {
  hideProductModal();
  const blockSelectedIsSlide =
    event.target.classList.contains("slideshow__slide");
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest("slideshow-component");
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener("shopify:block:deselect", function (event) {
  const blockDeselectedIsSlide =
    event.target.classList.contains("slideshow__slide");
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest("slideshow-component");
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay)
    parentSlideshowComponent.play();
});

document.addEventListener("shopify:section:load", () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector("[id^=EnableZoomOnHover]");
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement("script");
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  document
    .querySelectorAll(`[data-section="${event.detail.sectionId}"]`)
    .forEach((element) => {
      element.remove();
      document.body.classList.remove("overflow-hidden");
    });
});

document.addEventListener("shopify:section:reorder", () => hideProductModal());

document.addEventListener("shopify:section:select", () => hideProductModal());

document.addEventListener("shopify:section:deselect", () => hideProductModal());

document.addEventListener("shopify:inspector:activate", () =>
  hideProductModal()
);

document.addEventListener("shopify:inspector:deactivate", () =>
  hideProductModal()
);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".hardtop-box").forEach((box) => {
    const button = box.querySelector(".toggle-button");
    const overlay = box.querySelector(".vehicle-overlay");

    if (!button || !overlay) return;

    button.addEventListener("click", (e) => {
      e.stopPropagation();
      overlay.classList.add("show");
    });

    box.addEventListener("mouseleave", () => {
      overlay.classList.remove("show");
    });
  });
});
